'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415 from "./presto.-Freemium2-F-A-Add-View$$anon$15.js";
import * as $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024 from "./presto.types$-Freemium-Seed-Result$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$14() {
  this.aUK = null;
  this.aUC = null;
  this.aUD = false;
  this.aUL = null;
  this.aUM = false;
  this.aUP = null;
  this.aUI = null;
  this.aUJ = false;
  this.aUE = null;
  this.aUF = false;
  this.aUG = null;
  this.aUH = false;
  this.aUN = false;
  this.aUO = false;
  this.aUK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aUP = "FreemiumSeedResult";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$14 as $c_Lpresto_Freemium2FAAddView$$anon$14 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$14;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$14() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$14 as $h_Lpresto_Freemium2FAAddView$$anon$14 };
$h_Lpresto_Freemium2FAAddView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aUK;
});
$p.M = (function() {
  if ((!this.aUD)) {
    this.aUC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aUD = true;
  }
  return this.aUC;
});
$p.O = (function() {
  if ((!this.aUM)) {
    this.aUL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aUM = true;
  }
  return this.aUL;
});
$p.E = (function() {
  return this.aUP;
});
$p.t = (function() {
  if ((!this.aUJ)) {
    this.aUI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aUJ = true;
  }
  return this.aUI;
});
$p.N = (function() {
  if ((!this.aUF)) {
    this.aUE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aUF = true;
  }
  return this.aUE;
});
$p.Q = (function() {
  if ((!this.aUH)) {
    this.aUG = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415.$c_Lpresto_Freemium2FAAddView$$anon$15();
    this.aUH = true;
  }
  return this.aUG;
});
$p.v = (function() {
  if ((!this.aUO)) {
    this.aUN = false;
    this.aUO = true;
  }
  return this.aUN;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee133) => ((p) => \u03b4scrutinee133.cFW(p)))($j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024.$m_Lpresto_types$FreemiumSeedResult$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$14, "presto.Freemium2FAAddView$$anon$14", ({
  Jf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$14 as $d_Lpresto_Freemium2FAAddView$$anon$14 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$14.js.map
